<label class="control" [class.disabled]="disabled()">
    <span class="box">
        <input
            [class.checked]="value()"
            type="radio"
            [name]="name()"
            [disabled]="disabled()"
            [required]="required()"
            [checked]="value()"
            (change)="select()"
        />
        <span class="radio-dot" [hidden]="!value()"></span>
    </span>
    <span class="text"><ng-content></ng-content></span>
</label>
